<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <a routerLink="/ledgers/new" class="btn btn-primary btn-sm" style="width: 100%">
              <i class="fas fa-plus-circle"></i>
              &nbsp;Add Ledger Adjustments
            </a>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="search($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="searchParams.per_page"
                [(ngModel)]="searchParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <span class="badge badge-primary" *ngIf="count > 1 || count == 0">{{count}} Ledgers</span>
                <span class="badge badge-primary" *ngIf="count == 1">{{count}} Ledger</span>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <button type="button" [disabled]="searching" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="year">Year:</label>
                            <select class="form-control" id="year" [(ngModel)]="searchParams['year']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="year" *ngFor="let year of searchOptions.years">{{year}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="chart-of-account-type">Chart of Account Type:</label>
                            <select class="form-control" id="chart-of-account-type" [(ngModel)]="searchParams['chart_of_account_type_id']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="chart_of_account_type.id" *ngFor="let chart_of_account_type of searchOptions.chart_of_account_types">{{chart_of_account_type.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="chart-of-account">Chart of Account:</label>
                            <select class="form-control" id="chart-of-account" [(ngModel)]="searchParams['chart_of_account_id']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="chart_of_account.id" *ngFor="let chart_of_account of searchOptions.chart_of_accounts">{{chart_of_account.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="ledger-type">Ledger Type:</label>
                            <select class="form-control" id="ledger-type" [(ngModel)]="searchParams['category_1']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="ledger_type" *ngFor="let ledger_type of searchOptions.ledger_types">{{ledger_type}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="contact-name">Client Name:</label>
                            <app-contact-search id="contact-name" [contactId]="searchParams['search[contact_id]']" (clearContact)="searchParams['search[contact_id]'] = undefined" [placeholder]="'Search and select'" [small_input]="false" (contact_id)="searchParams['search[contact_id]']=$event"></app-contact-search>
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="text" id="amount" name="amount" [(ngModel)]="searchParams['search[amount]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Entry Group:</label>
                            <input class="form-control" type="number" id="entry-group" name="entry-group" [(ngModel)]="searchParams.entry_group_ids" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="order-by">Order By:</label>
                                <select class="form-control" id="order-by" [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor="let orderBy of searchOptions.order_by" [value]="orderBy.value">{{orderBy.label}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="in-order-of">In Order Of:</label>
                                <select class="form-control" id="in-order-of" [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderDirection of searchOptions.order_direction' [value]='orderDirection.value'>{{orderDirection.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                                <input [checked]="searchParams.reversal == 'all'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                                <input [checked]="searchParams.reversal == 'hide_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Hide Reversed</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                                <input [checked]="searchParams.reversal == 'only_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Only Reversed</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <button (click)="searchParams.page = 1; search(null, true)" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
                                Search
                                <span *ngIf="searching">
                                    &nbsp;
                                    <i class="fas fa-spinner fa-fw fa-pulse"></i>
                                </span>
                            </button>
                        </div>
                        <div class="form-group">
                            <!-- target="_blank" rel="noopener noreferrer" -->
                            <a class="btn btn-primary btn-sm" target="_blank" style="width: 100%" type="button" [href]="'/' + downloadCsvUrl" (click)="downloadCsv()">
                                Download CSV
                            </a>
                        </div>
                    </form>
                    <div *ngIf="isAccounting">
                        <a href="#" (click)="goToRailsPage($event, '/ledgers/ledger_balance_sheet_report')">Display Balance Sheet</a><br>
                        <a href="#" (click)="goToRailsPage($event, '/ledgers/ledger_balance_sheet_report?to_date=true')">Balance Sheet to {{currentDate}}</a><br>
                        <a href="#" (click)="goToRailsPage($event, '/ledgers/ledger_p_and_l_report')">Display P&L</a>
                    </div>
                    <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                        <table class="table" style="transform: rotateX(180deg);">
                            <thead>
                                <tr>
                                    <th colspan="2">Totals</th>
                                </tr>
                                <tr>
                                    <th class="text-right">Credits</th>
                                    <th class="text-right">Debits</th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr>
                                    <td class="text-right">
                                        <span *ngIf="totals.credits">{{totals.credits | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!totals.credits"></span>
                                    </td>
                                    <td class="text-right">
                                        <span *ngIf="totals.debits">{{totals.debits | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!totals.debits"></span>
                                    </td>
                               </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Ledgers</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table table-striped" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th></th>
                                <th>Group</th>
                                <th>Date</th>
                                <th>Account</th>
                                <th>Description</th>
                                <th class="text-right">Debit</th>
                                <th class="text-right">Credit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ledger of ledgers">
                                <td><a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [href]="'/ledgers/' + ledger.id">{{ledger.id}}</a></td>
                                <td><a [href]="ledger.tree_link_path"><i class="fas fa-tree"></i></a></td>
                                <td><a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [href]="'/entry_groups/' + ledger.entry_group_id">{{ledger.entry_group_id}}</a></td>
                                <td [ngClass]="{'lightgray': ledger.color_conditions.light_colored}">{{ledger.date}}</td>
                                <td>
                                    <span [ngClass]="{'lightgray': ledger.color_conditions.light_colored}">{{ledger.chart_of_account_type_name}}</span><br>
                                    <a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [href]="'/chart_of_accounts/' + ledger.chart_of_account_id">{{ledger.chart_of_account.name}}</a>
                                </td>
                                <td>
                                    <span *ngIf="ledger.contact">
                                        <a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [routerLink]="'/companies/' + ledger.contact_id" *ngIf="ledger.contact.company_name">{{ledger.contact.display_name}}</a>
                                        <a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [routerLink]="'/persons/' + ledger.contact_id" *ngIf="!ledger.contact.company_name">{{ledger.contact.display_name}}</a>
                                    </span>
                                    &nbsp;
                                    <span [ngClass]="{'lightgray': ledger.color_conditions.light_colored}" [innerHTML]="ledger.description | safeHtml"></span><br>
                                    <span *ngIf="ledger.is_reversed"><span [ngClass]="{'lightsalmon': ledger.color_conditions.light_colored}">Reversed By:</span><a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [href]="'/entries/' + ledger.reverse_entry_id">{{ledger.reverse_entry_id}}</a></span>
                                    <span *ngIf="ledger.is_reversal"><span [ngClass]="{'lightsalmon': ledger.color_conditions.light_colored}">Reverses:</span><a [ngClass]="{'lightblue': ledger.color_conditions.light_colored}" [href]="'/entries/' + ledger.reverses.id">{{ledger.reverses.id}}</a></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf='ledger.debit' [ngClass]="{'lightgray': ledger.color_conditions.light_colored}">{{ledger.debit | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf='!ledger.debit'></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf='ledger.credit' [ngClass]="{'lightgray': ledger.color_conditions.light_colored}">{{ledger.credit | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf='!ledger.credit'></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="responsive-sidebar-toggle-btn" (click)="sidebarOpen = !sidebarOpen">
    <button type="button" class="btn" [ngClass]="{ 'btn-primary': !sidebarOpen, 'btn-danger': sidebarOpen }">
      <i class="fas" [ngClass]="{ 'fa-bars': !sidebarOpen, 'fa-times': sidebarOpen }"></i>
    </button>
</div>